import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Flex from "../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../components/OutlineCard";
import { ScrollArea } from "../../../../../../../components/ScrollBar";
import Text from "../../../../../../../components/Text";
import { usePatientAllergyList } from "../../../../../../../queries/allergies/use-patient-allergies-list";
import { DEF_PAGINATION } from "../../../../../../../utils/utils";

export const AllergyView = ({ isVisitNote }: { isVisitNote?: boolean }) => {
  // const appointmentId = useSearchParams()[0].get("appointmentid") as any;

  // TODO: revamp remove this old patientId after new implementation tested.
  const patientIdOld = useSearchParams()[0].get("patientid") as any;
  const { patientId } = useParams();
  const [resolvedPatientId] = useState(patientIdOld ?? patientId);

  const { data: allergyList } = usePatientAllergyList({
    patientUuid:
      isVisitNote || !resolvedPatientId ? undefined : (resolvedPatientId ?? ""),
    // appointmentId: (isVisitNote || !resolvedPatientId) ? appointmentId : undefined,
    pagination: DEF_PAGINATION,
    archive: false,
  });

  return (
    <Flex flexDirection={"column"} gap={1.3} width={"100%"} height={"50%"}>
      <OutlineCard style={{ width: "100%", minHeight: "100%" }}>
        <Text c={"error"} fontWeight={"medium"}>
          ALLERGIES
        </Text>
        <ScrollArea height={"95%"}>
          <Flex mt={2} flexDirection={"column"} gap={1}>
            {allergyList?.data?.content?.map((it: any, ind: any) => (
              <Text>{ind + 1 + " . " + it?.allergy}</Text>
            ))}
          </Flex>
        </ScrollArea>
      </OutlineCard>
    </Flex>
  );
};
